import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d2af836"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "map-table-container" }
const _hoisted_2 = {
  key: 0,
  class: "table-controls"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  ref: "table",
  class: "table-data"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"50px","min-width":"50px"} }, "IMPORT", -1))
const _hoisted_6 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_7 = {
  key: 1,
  style: {"display":"flex","gap":"5px","align-items":"center"}
}
const _hoisted_8 = { style: {"position":"relative"} }
const _hoisted_9 = { style: {"width":"50px","height":"48px","min-width":"50px","display":"flex","align-items":"center"} }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { style: {"width":"50px","height":"48px","min-width":"50px","display":"flex","align-items":"center"} }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  key: 2,
  class: "table-loading"
}
const _hoisted_14 = {
  key: 3,
  class: "table-footer"
}
const _hoisted_15 = { class: "table-pagination" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-angle-down" }, null, -1))
const _hoisted_17 = {
  key: 0,
  class: "per-page-selector-menu"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-chevron-left" }, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-chevron-right" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_imdex_checkbox = _resolveComponent("imdex-checkbox")!
  const _component_imdex_select = _resolveComponent("imdex-select")!
  const _component_imdex_spinner = _resolveComponent("imdex-spinner")!
  const _component_imdex_btn = _resolveComponent("imdex-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.title)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.title), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("table", _hoisted_4, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", {
              style: _normalizeStyle(
						_ctx.options != null && _ctx.options.thead != null && _ctx.options.thead.background != null
							? `background:${_ctx.options.thead.background}`
							: ``
					)
            }, [
              _hoisted_5,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tempTableData.columns, (thead, i) => {
                return (_openBlock(), _createElementBlock("th", {
                  style: _normalizeStyle(_ctx.getStyleFromOptions(thead.name)),
                  key: i
                }, [
                  _createElementVNode("span", _hoisted_6, [
                    (_ctx.isVisible('h-' + thead.name))
                      ? _renderSlot(_ctx.$slots, 'h-' + thead.name, {
                          key: 0,
                          row: thead.name,
                          value: thead.name
                        }, undefined, true)
                      : (_openBlock(), _createElementBlock("span", _hoisted_7, [
                          _createVNode(_component_imdex_checkbox, {
                            disabled: _ctx.mappedColumns.indexOf(thead.name) > -1,
                            secondary: "",
                            value: thead.selected,
                            "onUpdate:value": ($event: any) => ((thead.selected) = $event)
                          }, null, 8, ["disabled", "value", "onUpdate:value"]),
                          _createTextVNode(" " + _toDisplayString(_ctx.formatHeader(thead.name)), 1)
                        ])),
                    (_ctx.sortName == thead.name)
                      ? (_openBlock(), _createElementBlock("i", {
                          key: 2,
                          class: _normalizeClass(["fa", { 'fa-arrow-down': _ctx.sort > 0, 'fa-arrow-up': _ctx.sort < 0 }])
                        }, null, 2))
                      : _createCommentVNode("", true)
                  ])
                ], 4))
              }), 128))
            ], 4)
          ]),
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", _hoisted_8, [
              _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.$t("import.mapTable.type")), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tempTableData.columns, (td, t) => {
                return (_openBlock(), _createElementBlock("td", {
                  key: t,
                  class: _normalizeClass({
							disabled: !(_ctx.columnsSelected.indexOf(t) > -1),
							mapped: _ctx.mappedColumns.indexOf(td.name) > -1
						})
                }, [
                  _createVNode(_component_imdex_select, {
                    items: 
								_ctx.availableStatsDatatypes
									? _ctx.availableStatsDatatypes[td.name]
									: [
											{
												text: _ctx.$t(`import.mapTable.categorical`),
												value: 'categorical'
											},
											{
												text: _ctx.$t(`import.mapTable.continuous`),
												value: 'continuous'
											}
									  ]
							,
                    value: td.statsDataType,
                    "onUpdate:value": ($event: any) => ((td.statsDataType) = $event)
                  }, null, 8, ["items", "value", "onUpdate:value"])
                ], 2))
              }), 128))
            ]),
            false
              ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                  _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.$t(`import.mapTable.unit`)), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tempTableData.columns, (td, t) => {
                    return (_openBlock(), _createElementBlock("td", {
                      key: t,
                      class: _normalizeClass({ disabled: !(_ctx.columnsSelected.indexOf(t) > -1) })
                    }, [
                      _withDirectives(_createVNode(_component_imdex_select, {
                        items: _ctx.availableUnits,
                        disabled: td.statsDataType == 'categorical',
                        value: td.units,
                        "onUpdate:value": ($event: any) => ((td.units) = $event)
                      }, null, 8, ["items", "disabled", "value", "onUpdate:value"]), [
                        [_vShow, td.statsDataType == 'continuous']
                      ])
                    ], 2))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredData, (tr, i) => {
              return (_openBlock(), _createElementBlock("tr", { key: i }, [
                _createElementVNode("td", null, _toDisplayString(i + 1), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tempTableData.columns, (td, t) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: t,
                    style: _normalizeStyle(_ctx.getRowStyleFromOptions()),
                    class: _normalizeClass({ disabled: !(_ctx.columnsSelected.indexOf(t) > -1) })
                  }, [
                    (_ctx.isVisible(td.name))
                      ? _renderSlot(_ctx.$slots, td.name, {
                          key: 0,
                          row: tr,
                          value: tr[td.name]
                        }, undefined, true)
                      : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(tr[td.name]), 1))
                  ], 6))
                }), 128))
              ]))
            }), 128))
          ])
        ], 512))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createVNode(_component_imdex_spinner, {
            width: "40",
            size: "3",
            indeterminite: "",
            color: "#808080"
          })
        ]))
      : _createCommentVNode("", true),
    false
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", {
              class: "per-page",
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.perPageSelector = !_ctx.perPageSelector), ["stop"]))
            }, [
              _createTextVNode(_toDisplayString(_ctx.perPage) + " " + _toDisplayString(_ctx.$t(`import.mapTable.perPage`)) + " ", 1),
              _hoisted_16,
              (_ctx.perPageSelector)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createElementVNode("div", {
                      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => ((_ctx.perPage = 10), (_ctx.perPageSelector = false)), ["stop"])),
                      class: "per-page-option"
                    }, _toDisplayString(_ctx.$t(`import.mapTable.10perPage`)), 1),
                    _createElementVNode("div", {
                      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => ((_ctx.perPage = 20), (_ctx.perPageSelector = false)), ["stop"])),
                      class: "per-page-option"
                    }, _toDisplayString(_ctx.$t(`import.mapTable.20perPage`)), 1),
                    _createElementVNode("div", {
                      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => ((_ctx.perPage = 50), (_ctx.perPageSelector = false)), ["stop"])),
                      class: "per-page-option"
                    }, _toDisplayString(_ctx.$t(`import.mapTable.50perPage`)), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", null, _toDisplayString(_ctx.perPage * (_ctx.page - 1) + 1) + " - " + _toDisplayString(_ctx.tempTableData.tableData.length >= _ctx.perPage * _ctx.page
							? _ctx.perPage * _ctx.page
							: _ctx.tempTableData.tableData.length) + " " + _toDisplayString(_ctx.$t(`import.mapTable.of`)) + " " + _toDisplayString(_ctx.tempTableData.tableData.length), 1),
            _createElementVNode("div", null, [
              _createVNode(_component_imdex_btn, {
                onClick: _ctx.prevPage,
                disabled: _ctx.page == 1,
                text: "",
                compact: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_18
                ]),
                _: 1
              }, 8, ["onClick", "disabled"]),
              _createVNode(_component_imdex_btn, {
                onClick: _ctx.nextPage,
                text: "",
                disabled: !_ctx.hasNextPage,
                compact: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_19
                ]),
                _: 1
              }, 8, ["onClick", "disabled"])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}